import React, { useState, useEffect } from 'react'
import { v1 } from "uuid";
import moment from 'moment';
import { TableToolbar, TableToolbarContent, TableToolbarSearch } from 'carbon-components-react';

import callPostApi from 'requests/PostRequests';
import DashboardSummary from '../DashboardSummaryNew';
import * as Constants from '../../../requests/URLConstants';
import DashboardTable from '../DashboardTable';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as DashboardConstants from '.././DashboardConstants';
import * as tableHeaders from './tableHeaders';
import * as workspaces from '../../../config/WorkspaceConstants';

require("./_capacity-management.scss");

const UllCapacityManagement = (props) => {
    const [botOnBoardingReport, setBotOnBoardingReport] = useState([]);
    const [searchedBotOnBoardingReport, setSearchedBotOnBoardingReport] = useState([]);
    const [botOnBoardingReportLoading, setBotOnBoardingReportLoading] = useState(false);
    const [resourceUtilizationData, setResourceUtilizationData] = useState([]);
    const [resourceUtilizationLoading, setResourceUtilizationLoading] = useState(false);
    const [capacityManagementSummaryData, setCapacityManagementSummaryData] = useState([]);

    const getCapacityManagementSummaryData = (param) => {
        let summary = [{
            title: DashboardConstants.NoOfResources,
            value: param.resources
        },
        {
            title: DashboardConstants.AverageUtilization + "(%)",
            value: param.averageUtilization
        },
        {
            title: DashboardConstants.BotsExceedingUtilization,
            value: param.exceedingUtilization
        }]
        setCapacityManagementSummaryData(summary);
    };

    useEffect(() => {
        getResourceUtilization(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotOnBoardingReport(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "resource": dashboardFilterSelectionsAutomation.resource,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    const prepareBotOnboardingData = (response) => {
        let tableData = [];
        let tableObj = {};
        if (response) {
            let buckets = response?.aggregations?.["2"]?.buckets || [];

            for (let i = 0; i < buckets.length; i++) {
                let statusBuckets = buckets[i]?.["8"]?.buckets || [];

                for (let j = 0; j < statusBuckets.length; j++) {
                    let techBuckets = statusBuckets[j]?.["tech"]?.buckets || [];

                    for (let k = 0; k < techBuckets.length; k++) {
                        let botBuckets = techBuckets[k]?.["BOT ID"]?.buckets || [];

                        for (let l = 0; l < botBuckets.length; l++) {
                            tableObj = {
                                id: v1(),
                                automataName: buckets[i].key,
                                client: '',
                                model: statusBuckets[j]?.key || '-',
                                onBoardingDate: botBuckets?.[l]?.[10]?.hits?.hits?.[0]?.fields?.Onboarding_dt?.[0] || '-',
                                offBoardingDate: botBuckets?.[l]?.[11]?.hits?.hits?.[0]?.fields?.offboarding_string?.[0] || '-',
                                status: botBuckets?.[l]?.[12]?.hits?.hits?.[0]?.fields?.Status || '-',
                                executions: techBuckets[k]?.doc_count || 0,
                                technology: techBuckets?.[k]?.key || '-',
                                botId: botBuckets?.[l]?.key || '-',
                            }

                            tableData.push(tableObj);
                        }
                    }
                }
            }
        }
        return tableData;
    };

    const getBotOnBoardingReport = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotOnBoardingReportLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTONBOARDINGREPORTULL, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareBotOnboardingData(resp);
                    setBotOnBoardingReport(formattedData);
                    setBotOnBoardingReportLoading(false);
                }).catch((error) => {
                    setBotOnBoardingReportLoading(false);
                });
        }
    };

    const prepareResourceUtilizationData = (response) => {
        let tableData = [];
        let tableObj = {};
        let summaryData = {};
        let totalUtilization = 0;
        let exceedingUtilization = 0;
        let utilization = 0;
        if (response) {
            for (let i = 0; i < response.length; i++) {
                utilization = response[i].utilization ? Number(response[i].utilization) : 0;
                tableObj = {
                    id: (i + 1).toString(),
                    resource: response[i].resource,
                    utilization: utilization ? utilization.toFixed(2) + "%" : '-'
                }
                totalUtilization = totalUtilization + utilization;
                exceedingUtilization = utilization > 80 ? exceedingUtilization + 1 : exceedingUtilization;
                tableData.push(tableObj);
            }
            summaryData = {
                resources: response.length,
                averageUtilization: totalUtilization / response.length,
                exceedingUtilization: exceedingUtilization
            }
        }
        return { tableData, summaryData };
    };

    const getResourceUtilization = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setResourceUtilizationLoading(true);
            let formattedData = [];
            // send minTime, maxtime in epoch format
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareResourceUtilizationData(resp);
                    setResourceUtilizationData(formattedData.tableData);
                    getCapacityManagementSummaryData(formattedData.summaryData)
                    setResourceUtilizationLoading(false);
                }).catch((error) => {
                    setResourceUtilizationLoading(false);
                });
        }
    };

    const searchTable = (event) => {
        let searchString = (event.target.value).toUpperCase();
        let searchResult = [];
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            newList = botOnBoardingReport.filter(element => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        string = element[property] ? element[property] : '';
                        string = string ? string.toString() : '';
                        pattern = new RegExp('(\\w*' + searchString + '\\w*)', 'gi');
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            searchResult = searchResult.concat([element]);
                            return searchResult;
                        }
                    }
                }
            });
            setSearchedBotOnBoardingReport(newList);
        } else {
            setSearchedBotOnBoardingReport(botOnBoardingReport);
        }
    };

    return (
        <div className="top-margin dashboard capacity-management">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={resourceUtilizationLoading} summary={capacityManagementSummaryData} title={DashboardConstants.CapacityManagementSummary} />
                </div>
                <div className="dashboard-charts-container">
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.ResourceUtilizationReport}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={resourceUtilizationData} headers={tableHeaders.resourceUtilizationHeaders} title={DashboardConstants.ResourceUtilizationReport} filename={DashboardConstants.ResourceUtilizationFileName} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={resourceUtilizationLoading} rows={resourceUtilizationData} headers={tableHeaders.resourceUtilizationHeaders}
                                showPagination={true} isSortable={true} />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.AutomataOnboardingReport}</div>
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                        <TableToolbarSearch onChange={searchTable} />
                                    </TableToolbarContent>
                                </TableToolbar>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={botOnBoardingReport} headers={tableHeaders.automataOnboardingHeadersUll} title={DashboardConstants.AutomataOnboardingReport} filename={DashboardConstants.AutomataOnBoardingReportFileName} label={DashboardConstants.Download} />
                                </div>
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={botOnBoardingReportLoading} rows={searchedBotOnBoardingReport.length ? searchedBotOnBoardingReport : botOnBoardingReport} headers={tableHeaders.automataOnboardingHeadersUll}
                                showPagination={true} isSortable={true} />
                        </div>
                    </section>
                </div>
            </div>
        </div >
    );
};

export default UllCapacityManagement;
